import http from '../http/http';

export default {
  install: () => {
    (window as any).http = http;
  },
};
